import "./src/styles/css/responsive.css";
import "./src/styles/global.css";

function trackPageView() {
  if (typeof window === "undefined") return;
  const measurementId = String(window.__GSM_GA_MEASUREMENT_ID__ || "").trim();
  if (!measurementId || typeof window.gtag !== "function") return;

  const pagePath = `${window.location.pathname || "/"}${window.location.search || ""}${window.location.hash || ""}`;

  window.gtag("event", "page_view", {
    send_to: measurementId,
    page_path: pagePath,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export const onRouteUpdate = () => {
  trackPageView();
};
